export default __webpack_public_path__ + "static/men-bodymap-anterior-36c3e3137a92c0e8b618038cc5847d95.webp";